import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SIZE, STATUS, TYPE } from './helper';
import moduleStyles from '@dtsl/css-avatar/dist/index.module.css';
import Profile from '@dtsl/icons/dist/icons/react/Profile';
import { Tooltip } from '@dtsl/react/dist/components/Tooltip';
function Avatar(props) {
  const {
    size,
    type,
    label,
    status,
    testId,
    tooltip,
    className,
    tooltipValue,
    statusBorderColor,
    imgMetaData: {
      imgAltText,
      imgUrl
    }
  } = props;
  const avatarClasses = classNames({
    [moduleStyles['sib-avatar']]: true,
    [moduleStyles[`sib-avatar__size-${size}`]]: size,
    [moduleStyles[`sib-avatar__type-${type}`]]: type,
    [className]: !!className
  });
  const statusDotClasses = classNames({
    [moduleStyles['sib-avatar__status']]: true,
    [moduleStyles[`sib-avatar__status-${status}`]]: status === STATUS.ACTIVE,
    [moduleStyles[`sib-avatar__status-${size}`]]: status === STATUS.ACTIVE && size
  });
  const getAvatarContent = type => {
    switch (type) {
      case 'default':
      case 'initial':
        {
          return /*#__PURE__*/React.createElement("span", {
            className: moduleStyles[`sib-avatar__label sib-avatar__type--${type}`]
          }, label);
        }
      case 'image':
        {
          return /*#__PURE__*/React.createElement("span", {
            className: moduleStyles['sib-avatar__image-wrapper']
          }, /*#__PURE__*/React.createElement("img", {
            alt: imgAltText,
            src: imgUrl,
            className: moduleStyles['sib-avatar__image']
          }));
        }
      case 'icon':
        {
          return /*#__PURE__*/React.createElement(Profile, null);
        }
    }
  };
  const avatarHTML = /*#__PURE__*/React.createElement("div", {
    className: avatarClasses,
    "data-testid": testId ? testId : null,
    "aria-hidden": "true"
  }, getAvatarContent(type), status !== STATUS.INACTIVE ? /*#__PURE__*/React.createElement("span", {
    className: statusDotClasses,
    style: {
      outlineColor: statusBorderColor
    }
  }) : null);
  return tooltip ? /*#__PURE__*/React.createElement(Tooltip, tooltipValue, avatarHTML) : avatarHTML;
}
Avatar.defaultProps = {
  size: SIZE.MEDIUM,
  status: STATUS.ACTIVE,
  type: TYPE.DEFAULT,
  statusBorderColor: 'var(--sib-color_content-white)',
  className: '',
  label: '',
  imgMetaData: {},
  tooltip: false,
  tooltipValue: {},
  testId: null
};
Avatar.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPE)),
  size: PropTypes.oneOf(Object.values(SIZE)),
  status: PropTypes.oneOf(Object.values(STATUS)),
  statusBorderColor: PropTypes.string,
  label: PropTypes.string,
  imgMetaData: PropTypes.object,
  tooltip: PropTypes.oneOf([true, false]),
  tooltipValue: PropTypes.object,
  className: PropTypes.string,
  testId: PropTypes.string
};
export default Avatar;